import sendToServer from "./send-to-server";
import trackEvent from "./track-event";

const DashboardShare = {
  init() {
    if ($(".dashboard-share-form").length !== 1) return;

    $(".dashboard-share-shower").click(
      this.handleDashboardShareShowerClick.bind(this)
    );
    $(".dashboard-share-form .cancel").click(
      this.handleDashboardShareCancelClick.bind(this)
    );
    $(".dashboard-share-form .share-request-form").submit(
      this.handleSubmitDashboardShareForm.bind(this)
    );
  },

  handleDashboardShareShowerClick() {
    $(".dashboard-share-form").show();
    sendToServer(
      "/api/v2/dashboard_share/",
      {},
      this.handleDashboardShareRetrieved.bind(this),
      "GET"
    );
  },

  handleDashboardShareCancelClick() {
    $(".dashboard-share-form").hide();
  },

  handleDashboardShareRetrieved(response) {
    $(".dashboard-share-form .share-link").show();
    $(".dashboard-share-form .loading").hide();
    const shareType =
      $(".dashboard-share-form").data("share-type") == "badge"
        ? "/badges/"
        : "/shares/";
    $(".dashboard-share-form .share-link").val(
      "https://" +
        window.location.hostname +
        shareType +
        response.responseJSON.token
    );
  },

  handleSubmitDashboardShareForm() {
    let email =
      $(".dashboard-share-form .recipient-email").length > 0
        ? $(".dashboard-share-form .recipient-email").first().val()
        : null;
    let contactDetails =
      $(".dashboard-share-form .sender-contact-details").length > 0
        ? $(".dashboard-share-form .sender-contact-details").first().val()
        : null;
    if (email && !/[^ @]*@[^ @]*/.test(email)) {
      $(".dashboard-share-form .email-validation").show();
    } else {
      $(".dashboard-share-form .email-validation").hide();
      sendToServer(
        "/api/v2/dashboard_share",
        { recipient: email, contact_details: contactDetails },
        null,
        "PATCH"
      );
      $(".dashboard-share-form .submit-share-request").hide();
      $(".dashboard-share-form .sending").fadeIn();
      window.setTimeout(
        this.brieflyShowShareRequestConfirmation.bind(this),
        1000
      );
    }
    return false;
  },

  brieflyShowShareRequestConfirmation() {
    window.setTimeout(() => {
      $(".share-success-message").fadeOut();
    }, 3000);
    $(".share-success-message").fadeIn();
    $(".dashboard-share-form").fadeOut();
    $(".dashboard-share-form .submit-share-request").show();
    $(".dashboard-share-form .sending").hide();
    $(".dashboard-share-form .recipient-email").first().val("");
  },
};

$(document).ready(() => {
  DashboardShare.init();
});
